function getCookie(sKey) {
  return decodeURIComponent(document.cookie.replace(new RegExp('(?:(?:^|.*;)\\s*' + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1')) || null;
}

function initGoldlog() {
  // goldlog打点设置
  if (window.goldlog && window.goldlog.record) {
    const originRecord = window.goldlog.record;
    window.goldlog.record = function (key, type, param, checksum) {
      // 统一追加产品id和公司id、page_id
      param += `${param ? '&' : ''}st_page_id=${window.dmtrack_pageid}&cna=${getCookie('cna')}`;
      originRecord.apply(window.goldlog, [key, type, param, checksum]);
    };
  } else {
    // flasher载入的页面初始的时候没有dmtrack_pageid
    let tryCount = 0;
    const timer = window.setInterval(() => {
      tryCount += 1;
      if (window.dmtrack_pageid) {
        (window.goldlog_queue || (window.goldlog_queue = [])).push({
          action: 'goldlog.setMetaInfo',
          arguments: ['aplus-exinfo', `st_page_id=${window.dmtrack_pageid}&cna=${getCookie('cna')}`],
        });
        window.clearInterval(timer);
      } else if (tryCount > 100) {
        (window.goldlog_queue || (window.goldlog_queue = [])).push({
          action: 'goldlog.setMetaInfo',
          arguments: ['aplus-exinfo', `st_page_id=${window.dmtrack_pageid || ''}&cna=${getCookie('cna')}`],
        });
        window.clearInterval(timer);
      }
    }, 50);
  }
}

export default initGoldlog;
